module.exports = __webpack_public_path__ + "img/image-007.b3e396e3.png";